/**
 * Register Service Worker for PWA functionality
 */
export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    console.warn('Service Worker not supported')
    return false
  }

  try {
    const registration = await navigator.serviceWorker.register('/sw.js', {
      scope: '/'
    })

    console.log('Service Worker registered:', registration.scope)

    // Check for updates
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing
      console.log('Service Worker update found')

      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          // New service worker is ready
          showUpdateNotification()
        }
      })
    })

    return true
  } catch (error) {
    console.error('Service Worker registration failed:', error)
    return false
  }
}

/**
 * Show update notification to user
 */
function showUpdateNotification() {
  // Simple notification - can be enhanced with a UI component
  if (confirm('有新版本可用，是否重新載入？')) {
    window.location.reload()
  }
}

/**
 * Unregister Service Worker (for development/debugging)
 */
export async function unregisterServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return false
  }

  const registration = await navigator.serviceWorker.getRegistration()
  if (registration) {
    await registration.unregister()
    console.log('Service Worker unregistered')
    return true
  }

  return false
}
